import { map as _map } from 'lodash';
import { find as _find } from 'lodash';
import { filter as _filter } from 'lodash';

class InvoiceListController {
  constructor(authService, accountingService, loadingService, enums, $ngConfirm, $scope, $state, printService) {
    "ngInject";

    this.authService = authService;
    this.accountingService = accountingService;
    this.loadingService = loadingService;
    this.enums = enums;
    this.$ngConfirm = $ngConfirm;
    this.$scope = $scope;
    this.$state = $state;
    this.printService = printService;

    this.selectOptions = {};
    this.filterParams = {};

    this.reset();
  }

  reset() {
    const ctrl = this;

    this.filterParams.entityId = this.authService.authData.currentLocation.key;
    this.filterParams.number = '';
    this.filterParams.contact = '';
    this.filterParams.status = "";

    this.pagination = {
      totalItems: 0,
      currentPage: 1,
      pageSize: 10
    };

    this.filterParams.pageCriteria = {
      pageStart: 0,
      itemsToFetch: this.pagination.pageSize,
      sortExpression: 'created',
      ascending: false
    };

    this.notification = {
      type: 'info',
      msg: ''
    };

    this.listInvoices();
  }

  updatePageIndex() {
    if (this.pagination.currentPage === 1) {
      this.filterParams.pageCriteria.pageStart = 0;
    }
    else {
      this.filterParams.pageCriteria.pageStart = ((this.pagination.currentPage-1) * this.pagination.pageSize);
    }
  }

  updateSort(fieldName) {
    if (this.filterParams.pageCriteria.sortExpression === fieldName) {
      this.filterParams.pageCriteria.ascending = !this.filterParams.pageCriteria.ascending;
    }
    else {
      this.filterParams.pageCriteria.sortExpression = fieldName;
      this.filterParams.pageCriteria.ascending = true;
    }

    this.listInvoices();
  }

  listInvoices() {
    const ctrl = this;

    ctrl.updatePageIndex();

    ctrl.loadingService.showLoading('invoiceListing', 'Loading Invoices ...');

    ctrl.accountingService.listInvoices(ctrl.filterParams)
      .then(response => {
        ctrl.invoices = response.data.items;
        ctrl.pagination.totalItems = response.data.totalRecords;

        if (ctrl.pagination.totalItems === 0) {
          ctrl.notification = {
            type: 'info',
            msg: `No data to display`
          }
        }
        else {
          const pageEnd = (ctrl.filterParams.pageCriteria.pageStart + ctrl.pagination.pageSize) < response.data.totalRecords ? (ctrl.filterParams.pageCriteria.pageStart + ctrl.pagination.pageSize) :  response.data.totalRecords;

          ctrl.notification = {
            type: 'info',
            msg: `Currently display ${(ctrl.filterParams.pageCriteria.pageStart+1)} to ${pageEnd} out of ${ctrl.pagination.totalItems} invoices`
          }
        }
      })
      .catch(err => {
        ctrl.notification = {
          type: 'error',
          msg: "An error occurred while fetching invoices." + (err.data ? err.data.messageDetail : '')
        }
      })
      .finally(() => {
        ctrl.loadingService.hideLoading('invoiceListing');
      });
  }

  updateStatus(productId, status) {
    const ctrl = this;
    let title, content;

    switch(status) {
      case this.enums.OBJECT_ROW_STATE.Active:
        title = 'Activate Product';
        content = 'Are you sure you want to activate this product?';
        break;

      case this.enums.OBJECT_ROW_STATE.Inactive:
        title = 'Suspend Product';
        content = 'Are you sure you want to suspend this product?';
        break;

      case this.enums.OBJECT_ROW_STATE.Deleted:
        title = 'Delete Product';
        content = 'Are you sure you want to delete this product?';
        break;
    }

    this.$ngConfirm({
      title: title,
      content: content,
      type: 'red',
      buttons: {
        confirm: () => {
          ctrl.loadingService.showLoading('invoiceListing', 'Updating product status ...');

          ctrl.productsManagementService.updateStatus(this.authService.authData.currentLocation.key, productId, status)
            .then(response => {
              ctrl.listProducts();
            })
            .catch(err => {
              switch(err.status) {
                case 400:
                  ctrl.notification = {
                    type: 'error',
                    msg: err.data[0].value
                  }
                  break;

                default:
                  ctrl.notification = {
                    type: 'error',
                    msg: err.data.message
                  }
                  break;
              }                    
            })
            .finally(() => {
              ctrl.loadingService.hideLoading('invoiceListing');
            });
        },
        cancel: () => {}
      }
    });
  }

  newInvoice() {
    this.$state.go('editInvoice', {locationId: this.authService.authData.currentLocation.key, invoiceId: null});
  }

  editInvoice(invoiceId) {
    this.$state.go('editInvoice', {locationId: this.authService.authData.currentLocation.key, invoiceId: invoiceId});
  }

  printInvoice(invoiceId) {
    this.printService.printInvoice(invoiceId);
  }  
}

export default InvoiceListController;



// WEBPACK FOOTER //
// ./client/app/components/accounting/invoiceList/invoiceList.controller.js